module.exports = __webpack_public_path__ + "img/join.48aec37f.png";